import { withTranslation } from "react-i18next";

import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { Header } from '../Common/Header';
import ProductsUpload from '../../Models/ProductsUpload';
import Products from '../../Models/Products';
import SimpleReactValidator from 'simple-react-validator';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class PostRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            info: '',
            title: '',
            description: '',
            category: '',
            subCategory: '',
            date: '',
            categories: [],
            subCategories: [],
            budget: [],
            budget_value: '',
            // dob: moment().format(),
            dob: new Date(),
            cat_name: '',
            sub_cat_name: '',
            budget_amount: ''
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('11')}`,
            max: `:attribute :max ${this.props.t('9')} .`,
            required: ` :attribute ${this.props.t('29')}`,
            min: `:attribute :min ${this.props.t('10')}`,
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        this.getCategories();
        this.getBudgetList();
        this.dateChange = this.dateChange.bind(this);

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.postData = this.postData.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    getBudgetList() {
        Products.getBudget().then(res => {
            this.setState({ budget: res.data.message })
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    updateChange(e) {
        this.setState({
            budgets: e.target.value,
            budgetValue: e.target.key
        })
    }
    handleChange(e) {
        this.setState({
            category: this.refs.category.value
        })
        ProductsUpload.getSubCategory(e.target.value).then(res => {
            this.setState({
                subCategories: res.data.category_sub
            })
        })
    }
    handleChangesubcat(e) {
        this.setState({
            subCategory: this.refs.subCategory.value
        })
    }
    handleChangebudget(e) {
        this.setState({
            budget_value: this.refs.budget.value
        })
    }
    dateChange = date => {
        this.setState({
            dob: date
        });
    }
    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    handleSubmit(e) {
        e.preventDefault();
        // this.setState({
        //     budget_value: this.refs.budget.value
        // })
        // this.setState({
        //     category: this.refs.category.value
        // })
        // this.setState({
        //     subCategory: this.refs.subCategory.value
        // })
        let data = {
            budget: this.refs.budget.value,
            category: this.refs.category.value,
            subcategory: this.refs.subCategory.value
        }
        Products.getNames(data).then(res => {
            this.setState({ cat_name: res.data.cat })
            this.setState({ sub_cat_name: res.data.sub_cat })
            this.setState({ budget_amount: res.data.budget })
        })
        if (this.validator.allValid()) {
            console.log(data)
            console.log(this.state.budget)
            this.openModal();
        } else {
            this.validator.showMessages();
        }
    }

    postData(e) {
        document.getElementById("req_entry").disabled = true;
        e.preventDefault();
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        let data = {
            buyer_id: logged_user.id,
            title: this.state.title,
            application_date: this.state.date,
            content: this.state.description,
            category: this.state.category,
            sub_category: this.state.subCategory,
            budget: this.refs.budget.value
        }
        console.log(data);
        if (logged_user.user_type_id === 1) {
            Products.saveRequest(data).then(res => {
                if (parseInt(res.data.status) === 200) {
                    alert(this.props.t('4'));
                    this.props.history.push('/buyer-request-home');
                }
            })
        } else if (logged_user.user_type_id === 2) {
            Products.saveRequest(data).then(res => {
                if (parseInt(res.data.status) === 200) {
                    alert(this.props.t('4'));
                    this.props.history.push('/seller-buyer-request-home');
                }
            })
        } else if (logged_user.user_type_id === 3) {
            Products.saveRequest(data).then(res => {
                if (parseInt(res.data.status) === 200) {
                    alert(this.props.t('4'));
                    this.props.history.push('/affiliator-buyer-request-home');
                }
            })
        }
    }

    //button for responsive

    button() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="button_div">
                    <button type="submit" className="agree_button" style={{ width: '-webkit-fill-available' }}>{this.props.t('7')}</button>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="button_div">
                    <button type="submit" className="agree_button">{this.props.t('7')}</button>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div>
                        {/* <button >Open Modal</button> */}
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "", height: "350px" }}>
                                <div className="row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "4%", fontSize: '12px' }}>
                                            <legend style={{ width: "50%", color: "#008dc7", fontSize: "16px" }}>{this.props.t('20')}</legend>
                                            <div className="row">
                                                <div className="col-4" style={{ paddingRight: '0px' }}>
                                                    <span>{this.props.t('36')} :</span>
                                                </div>
                                                <div className="col-8">
                                                    <span>{this.state.title}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-4" style={{ paddingRight: '0px' }}>
                                                    <span>{this.props.t('37')} :</span>
                                                </div>
                                                <div className="col-8">
                                                    <span>
                                                        {this.state.description.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-4" style={{ paddingRight: '0px' }}>
                                                    <span>{this.props.t('30')} :</span>
                                                </div>
                                                <div className="col-8">
                                                    <span>{this.state.cat_name}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-4" style={{ paddingRight: '0px' }}>
                                                    <span>{this.props.t('27')} :</span>
                                                </div>
                                                <div className="col-8">
                                                    <span>{this.state.sub_cat_name}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-4" style={{ paddingRight: '0px' }}>
                                                    <span>{this.props.t('38')} :</span>
                                                </div>
                                                <div className="col-8">
                                                    <span>{this.state.budget_amount} {this.props.t('75')}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-4" style={{ paddingRight: '0px' }}>
                                                    <span>{this.props.t('39')} :</span>
                                                </div>
                                                <div className="col-8">
                                                    <span>{this.state.date}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('40')}</button>&nbsp;
                                        <button id="req_entry" onClick={this.postData} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('41')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <div className="">
                                    <div className="" style={{ textAlign: "left", fontSize: "20px", borderBottom: "1px solid #ccd0c9" }}>
                                        {this.props.t('12')}
                                        </div>
                                    <div className="">
                                        <div className="">
                                            <div className="container">
                                                <form onSubmit={this.handleSubmit.bind(this)}>
                                                    <div className="form-group" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                                        <label htmlFor="email" style={{ marginBottom: '0rem' }}><span className="request_fonts mr-3"><b>{this.props.t('30')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span></label>
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <select
                                                                    style={{ border: "1px solid #d8e6e8", height: "40px" }}
                                                                    className="catagory_select" ref="category"
                                                                    onChange={this.handleChange.bind(this)}
                                                                >
                                                                    <option value="">{this.props.t('13')} </option>
                                                                    {this.state.categories.map(cat =>
                                                                        <option value={cat.id} key={cat.id} >
                                                                            {cat.cat_name}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('30'), this.state.category, 'required')}
                                                                </span>
                                                            </div>
                                                            {/* <div className="col-md-1 mt-2 desktop_categories_between_icon">
                                                                    <span>{this.props.t('21')}</span>
                                                                </div> */}
                                                            <div className="col-md-4 " style={{ marginTop: '10px' }} >
                                                                <label htmlFor="email" style={{ marginBottom: '0rem' }}><span className="request_fonts mt-2 desktop_categories_between_icon"><b>{this.props.t('21')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span></label>
                                                                <select
                                                                    style={{ border: "1px solid #d8e6e8", height: "40px" }}
                                                                    className="catagory_select" ref="subCategory" id="sub_category" onChange={this.handleChangesubcat.bind(this)}
                                                                >
                                                                    <option value="">{this.props.t('13')} </option>
                                                                    {this.state.subCategories.map(rp =>
                                                                        // console.log(rp.cat_name)
                                                                        <option value={rp.id} key={rp.id}>
                                                                            {rp.cat_name}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('21'), this.state.subCategory, 'required')}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group" style={{ marginBottom: '10px' }}>
                                                        <label htmlFor="pwd" style={{ marginBottom: '0rem' }}><span className="request_fonts mr-4"><b>{this.props.t('36')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span></label>
                                                        <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder={this.props.t('2')} value={this.state.title} onChange={this.updateValue.bind(this, 'title')} />
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message(this.props.t('36'), this.state.title, 'required')}
                                                        </span>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="pwd" style={{ marginBottom: '0rem' }}><span className="request_fonts mr-4"><b>{this.props.t('37')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span></label>
                                                        <textarea className="form-control " rows="7" id="description" placeholder={this.props.t('0')+".."} value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message(this.props.t('37'), this.state.description, 'required')}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <div className="row mb-3">
                                                            <div className="col-md-4 request_fonts">
                                                                <span><b>{this.props.t('39')}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <input type="date"
                                                                    className="catagory_select" id="date" placeholder="Date"
                                                                    value={this.state.date} onChange={this.updateValue.bind(this, 'date')}
                                                                    style={{ height: "40px" }}
                                                                />
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('47'), this.state.date, 'required')}
                                                                </span>
                                                            </div>
                                                            <div className="col-md-2"></div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col-md-4 request_fonts">
                                                                <span><b>{this.props.t('38')}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <select
                                                                    className="catagory_select"
                                                                    onChange={this.updateChange.bind(this)}
                                                                    value={this.state.budgets}
                                                                    style={{ height: "40px" }}
                                                                    ref="budget"
                                                                >
                                                                    <option value='' >{this.props.t('13')}</option>
                                                                    {this.state.budget.map(rp =>
                                                                        <option value={rp.id} key={rp.budget_range}>
                                                                            {rp.budget_range}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('38'), this.state.budgets, 'required')}
                                                                </span>
                                                            </div>
                                                            <div className="col-md-2"></div>
                                                        </div>
                                                        {this.button()}
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div  className="wrapper">
                    <Header />
                    <div>
                        {/* <button >Open Modal</button> */}
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "600px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "22%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('20')}</legend>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('36')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('37')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>
                                                        {this.state.description.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('30')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.cat_name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('27')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.sub_cat_name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('38')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.budget_amount} {this.props.t('75')}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('39')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.date}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('40')}</button>&nbsp;
                                        <button id="req_entry" onClick={this.postData} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('41')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12 ">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8">
                                        <div className="">
                                            <div className="ml-4 mr-4" style={{ textAlign: "left", fontSize: "24px", borderBottom: "1px solid #ccd0c9" }}>
                                                {this.props.t('12')}
                                        </div>
                                            <div className="mini_padding">
                                                <div className="mini_padding inner-div">
                                                    <div className="container">
                                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                                            <div className="form-group">
                                                                <label htmlFor="email"><span className="request_fonts mr-3"><b>{this.props.t('30')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span></label>
                                                                <div className="row">
                                                                    <div className="col-md-7">
                                                                        <select
                                                                            style={{ border: "1px solid #d8e6e8", height: "40px" }}
                                                                            className="catagory_select" ref="category"
                                                                            onChange={this.handleChange.bind(this)}
                                                                        >
                                                                            <option value="">{this.props.t('13')} </option>
                                                                            {this.state.categories.map(cat =>
                                                                                <option value={cat.id} key={cat.id} >
                                                                                    {cat.cat_name}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message(this.props.t('30'), this.state.category, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-1 mt-2 mobile_categories_between_icon">
                                                                        <i className="fa fa-angle-right"></i>
                                                                    </div>

                                                                    {/* <div className="col-md-1 mt-2 desktop_categories_between_icon">
                                                                    <span>{this.props.t('21')}</span>
                                                                </div> */}
                                                                    <div className="col-md-4">
                                                                        <select
                                                                            style={{ border: "1px solid #d8e6e8", height: "40px" }}
                                                                            className="catagory_select" ref="subCategory" id="sub_category" onChange={this.handleChangesubcat.bind(this)}
                                                                        >
                                                                            <option value="">{this.props.t('13')} </option>
                                                                            {this.state.subCategories.map(rp =>
                                                                                // console.log(rp.cat_name)
                                                                                <option value={rp.id} key={rp.id}>
                                                                                    {rp.cat_name}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message(this.props.t('21'), this.state.subCategory, 'required')}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="small-hidden" >&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('36')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span></label>
                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder={this.props.t('2')} value={this.state.title} onChange={this.updateValue.bind(this, 'title')} />
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('36'), this.state.title, 'required')}
                                                                </span>
                                                            </div>
                                                            <div className="small-hidden">&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('37')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span></label>
                                                                <textarea className="form-control " rows="7" id="description" placeholder={this.props.t('0')+".."} value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('37'), this.state.description, 'required')}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-4">
                                                                        <span><b>{this.props.t('39')}</b></span>
                                                                        <span style={{ color: "red", fontSize: "11px", marginLeft: '15px' }}>*{this.props.t('64')}</span>
                                                                    </div>
                                                                    <div className="col-md-8">

                                                                        <input type="date"
                                                                            className="catagory_select" id="date" placeholder="Date"
                                                                            value={this.state.date} onChange={this.updateValue.bind(this, 'date')}
                                                                            style={{ height: "40px" }}
                                                                        />
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message(this.props.t('47'), this.state.date, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2"></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-4">
                                                                        <span><b>{this.props.t('38')}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('64')}</span>
                                                                    </div>
                                                                    <div className="col-md-8">
                                                                        <select
                                                                            className="catagory_select"
                                                                            onChange={this.updateChange.bind(this)}
                                                                            value={this.state.budgets}
                                                                            style={{ height: "40px" }}
                                                                            ref="budget"
                                                                        >
                                                                            <option value='' >{this.props.t('13')}</option>
                                                                            {this.state.budget.map(rp =>
                                                                                <option value={rp.id} key={rp.budget_range}>
                                                                                    {rp.budget_range}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message(this.props.t('38'), this.state.budgets, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2"></div>
                                                                </div>
                                                                {this.button()}
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
// const mapStateToProps = (state) => ({
//     buyerRequest: state.buyerRequest,
//     errors: state.errors,
// });
// PostRequest = connect(mapStateToProps, { buyerRequest })(withRouter(PostRequest));
export { PostRequest }



 PostRequest = withTranslation('src_Components_Request_PostRequest')(PostRequest);
